<template>
	<date-range-picker
		v-model="filter.range"
		:appendToBody="true"
		:opens="'right'"
		:locale-data="{
			firstDay: 1,
			format: 'dd mmm yyy',
			applyLabel: $t('label.apply'),
			cancelLabel: $t('label.cancel'),
		}"
	>
		<template v-slot:input="picker" style="border: none">
			<v-text-field
				label="Date"
				tile
				dense
				readonly
				:value="
					moment(picker.startDate) + ' - ' + moment(picker.endDate)
				"
			></v-text-field
		></template>
	</date-range-picker>
</template>
<script>
	import moment from "moment";
	export default {
		data() {
			return {
				//
			};
		},
		computed: {
			filter: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},
		},
		watch: {
			filter: {
				handler() {
					this.$emit("filter");
				},
				deep: true,
			},
		},
		methods: {
			moment(date) {
				return moment(date).format("DD MMM YYYY");
			},
		},
	};
</script>